// extracted by mini-css-extract-plugin
module.exports = {"feedback":"Feedback_feedback__3kt2i"};